import { dataSmileySolid } from 'dls-icons-data'
import { createIcon } from '../common'

const IconSmileySolid = /*#__PURE__*/createIcon(dataSmileySolid)
export default IconSmileySolid
